import { useEffect, useState } from 'react';
import { getDownloadURL, ref, FirebaseStorage } from 'firebase/storage';
import * as Sentry from '@sentry/browser';
import { backendStorage } from '../constants/firebaseModular';

export function useStorageDownloadUrl(
  storagePath: string | null | undefined,
  storageInstance: FirebaseStorage = backendStorage,
) {
  const [url, setUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(Boolean(storagePath));
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    if (!storagePath) {
      setUrl(null);
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    (async () => {
      try {
        const storageRef = ref(storageInstance, storagePath);
        const downloadUrl = await getDownloadURL(storageRef);
        if (!cancelled) {
          setUrl(downloadUrl);
          setIsLoading(false);
        }
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        Sentry.captureException(e, {
          extra: { storagePath },
        });
        if (!cancelled) {
          setError(e);
          setUrl(null);
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [storagePath, storageInstance]);

  return { url, isLoading, error };
}
